/// <amd-module name="Search/Shared/Components/HighlightComponent" />
export * from "./HighlightComponent/index";
